import React from 'react'
import styled from 'styled-components'
import { Field, Formik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import MaskedInput from 'react-text-mask'
import sendForm from '../../services/sendforms'
import { cpfValidation } from '../../util/cpfValidation'

const Fieldset = styled.fieldset`
  width: 100%;
  border: none;
  display: inline;
  margin: 0;
  padding: 0;
  position: relative;
  span {
    color: red;
    bottom: -30px;
    left: 0;
    font-size: 14px;
  }
`
const phoneNumberMask = [
  '(',
  /[1-9]/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]
const cpfMask = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
]
const dataMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]

const ContactForm = () => {
  const ContactSchema = Yup.object({
    field_name: Yup.string()
      .min(2, 'Seu nome precisa ter mais de duas letras')
      .required('Campo obrigatório'),
    field_email: Yup.string()
      .email('E-mail inválido')
      .required('Campo obrigatório'),
    field_categoria: Yup.string().required('Campo obrigatório'),
    field_assunto: Yup.string()
      .required('Campo obrigatório')
      .oneOf(['Contato', 'Orçamento'], 'Escolha um assunto'),
    field_nascimento: Yup.string().required('Campo obrigatório'),
    field_cel: Yup.string().required('Campo obrigatório'),
    field_cpf: Yup.string()
      .test('cpf', 'O CPF é inválido.', value => cpfValidation(value))
      .required('Campo obrigatório'),
    field_message: Yup.string().required('Campo obrigatório'),
  })
  const initialValues = {
    field_assunto: '',
    field_categoria: '',
    field_name: '',
    field_email: '',
    field_parto: '',
    field_nascimento: '',
    field_cel: '',
    field_cpf: '',
    field_message: '',
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ContactSchema}
      onSubmit={async (values, { resetForm }) => {
        toast.info('Enviando', {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          draggable: true,
          progress: undefined,
        })
        const wordpressFormId = '10983'
        const response = await sendForm(wordpressFormId, values)
        if (response.status === 'mail_sent') {
          toast.success(response.message, {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'formSend',
            category: 'Formulário',
            action: 'Send',
            label: `Contato: Categoria - ${values.field_categoria} `,
          })
          resetForm(initialValues)
        } else {
          toast.error(response.message, {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      }}
    >
      {props => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <Fieldset className="half">
              <select
                name="field_assunto"
                onChange={handleChange}
                className={
                  touched.field_assunto && errors.field_assunto ? 'error' : null
                }
              >
                <option>Assunto</option>
                <option value="Contato">Contato</option>
                <option value="Orçamento">Orçamento</option>
              </select>
              {touched.field_assunto && errors.field_assunto ? (
                <span>{errors.field_assunto}</span>
              ) : null}
            </Fieldset>
            <Fieldset className="half">
              <select
                name="field_categoria"
                onChange={handleChange}
                className={
                  touched.field_categoria && errors.field_categoria
                    ? 'error'
                    : null
                }
              >
                <option>Categoria</option>
                <option value="Dúvidas">Dúvidas</option>
                <option value="Informações">Informações</option>
                <option value="Sugestões">Sugestões</option>
                <option value="Reclamações">Reclamações</option>
                <option value="Elogios">Elogios</option>
              </select>
              {touched.field_categoria && errors.field_categoria ? (
                <span>{errors.field_categoria}</span>
              ) : null}
            </Fieldset>

            <Fieldset>
              <input
                id="field_name"
                name="field_name"
                type="text"
                onChange={handleChange}
                value={values.field_name}
                placeholder="Nome*"
                className={
                  touched.field_name && errors.field_name ? 'error' : null
                }
              />
              {touched.field_name && errors.field_name ? (
                <span>{errors.field_name}</span>
              ) : null}
            </Fieldset>
            <Fieldset>
              <input
                id="field_email"
                name="field_email"
                type="field_email"
                onChange={handleChange}
                value={values.field_email}
                placeholder="E-mail*"
                className={
                  touched.field_email && errors.field_email ? 'error' : null
                }
              />
              {touched.field_email && errors.field_email ? (
                <span className="half">{errors.field_email}</span>
              ) : null}
            </Fieldset>
            <Fieldset className="half">
              <Field name="field_parto">
                {({ field }) => (
                  <MaskedInput
                    {...field}
                    mask={dataMask}
                    id="field_parto"
                    placeholder="Data prevista para o parto"
                    type="text"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.field_parto && touched.field_parto ? 'error' : null
                    }
                  />
                )}
              </Field>
              {touched.field_partof && errors.field_parto ? (
                <span>{errors.field_parto}</span>
              ) : null}
            </Fieldset>
            <Fieldset className="half">
              <Field name="field_nascimento">
                {({ field }) => (
                  <MaskedInput
                    {...field}
                    mask={dataMask}
                    id="field_nascimento"
                    placeholder="Data de nascimento*"
                    type="tel"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.field_nascimento && touched.field_nascimento
                        ? 'error'
                        : null
                    }
                  />
                )}
              </Field>

              {touched.field_nascimento && errors.field_nascimento ? (
                <span>{errors.field_nascimento}</span>
              ) : null}
            </Fieldset>
            <Fieldset className="half">
              <Field name="field_cel">
                {({ field }) => (
                  <MaskedInput
                    {...field}
                    mask={phoneNumberMask}
                    id="field_cel"
                    placeholder="Celular*"
                    type="tel"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.field_cel && touched.field_cel ? 'error' : null
                    }
                  />
                )}
              </Field>
              {touched.field_cel && errors.field_cel ? (
                <span>{errors.field_cel}</span>
              ) : null}
            </Fieldset>
            <Fieldset className="half">
              <Field name="field_cpf">
                {({ field }) => (
                  <MaskedInput
                    {...field}
                    mask={cpfMask}
                    id="field_cpf"
                    placeholder="CPF*"
                    type="text"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      errors.field_cpf && touched.field_cpf ? 'error' : null
                    }
                  />
                )}
              </Field>
              {touched.field_cpf && errors.field_cpf ? (
                <span>{errors.field_cpf}</span>
              ) : null}
            </Fieldset>
            <textarea
              name="field_message"
              id="field_message"
              placeholder="Digite sua mensagem, dúvida ou sugestão*"
              onChange={handleChange}
              value={values.field_message}
              className={
                touched.field_message && errors.field_message ? 'error' : null
              }
            />
            <button
              onClick={() => {
                resetForm(initialValues)
              }}
              type="button"
            >
              Limpar
            </button>
            <button type="submit" disabled={isSubmitting}>
              Enviar
            </button>
          </form>
        )
      }}
    </Formik>
  )
}
export default ContactForm
